import React from 'react'
import { TabBar } from '../TabBar'
import styles from './styles.module.scss'
import logo from './assets/logo.png'
import { RainbowText } from '../RainbowText'
import { ExternalLinkBar } from '../ExternalLinkBar'
import { faDiscord } from '@fortawesome/free-brands-svg-icons'
import { faDownload, IconDefinition } from '@fortawesome/free-solid-svg-icons'

export const AppBar: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className='container'>
        <div className={styles.content}>
          <div className={styles.logoContainer}>
            <a className={styles.logo} href='/chatbot'>
              <img src={logo} alt='Draco.Bot Logo' />
              <span className='h4'>
                <RainbowText reverse text='Draco.Bot' />
              </span>
            </a>
          </div>
          <TabBar
            className={styles.tabs}
            tabs={[
              { caption: 'Home', location: '/chatbot' },
              { caption: 'Features', location: '/chatbot/features' },
              { caption: 'FAQs', location: '/chatbot/faqs' },
            ]}
          />
          <ExternalLinkBar
            className={styles.external}
            tabs={[
              {
                icon: faDownload as IconDefinition,
                location: '/chatbot/download',
                tip: 'Download Draco.Bot',
                external: false,
              },
              { icon: faDiscord as IconDefinition, location: 'https://discord.gg/5s2rhp8qBq', tip: 'Join our Discord Community' },
            ]}
          />
        </div>
      </div>
      <div className={styles.barBigBlur} />
      <div className={styles.barBlur} />
      <div className={styles.bar} />
    </div>
  )
}

export default AppBar
